import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { storeCtas } from "../content/seo";

const StoreCta = ({ variant = "discovery", className = "" }) => {
  const navigate = useNavigate();
  const cta = storeCtas[variant] || storeCtas.discovery;

  const handleClick = () => {
    if (variant === "scroll") {
      document
        .querySelector(cta.target)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    navigate(cta.href);
  };

  const content = (
    <Button variant="contained" onClick={handleClick} size="large">
      {cta.label}
    </Button>
  );

  if (className) {
    return <div className={className}>{content}</div>;
  }

  return content;
};

export default StoreCta;
